{
	"booking": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"bookings": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"call": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"chats": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"consents": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"employees": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_OWNER", "BUSINESS_CLIENT"]
	},
	"dashboard": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["BUSINESS_CLIENT"]
	},
	"history": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"home": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"invoices": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_OWNER", "BUSINESS_CLIENT"]
	},
	"therapyFundWallets": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_OWNER"]
	},
	"corporateInsurance": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["BUSINESS_CLIENT"]
	},
	"limits": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["BUSINESS_CLIENT"]
	},
	"profile": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER", "SERVICE_OWNER", "BUSINESS_CLIENT"]
	},
	"promo": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"schedule": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"settings": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_OWNER", "BUSINESS_CLIENT"]
	},
	"spSettings": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"symptomCheck": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"transactions": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_PROVIDER", "SERVICE_OWNER", "BUSINESS_CLIENT"]
	},
	"wallet": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"insurance": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"claimRequest": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"policySettings": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"partners": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	},
	"preVisitDashboard": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"prescriptionList": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"toolkit": {
		"allowedRegularUser": false,
		"allowedBusinessUsers": ["SERVICE_PROVIDER"]
	},
	"myExercises": {
		"allowedRegularUser": true,
		"allowedBusinessUsers": []
	}
}
